import { z } from 'zod'
export const ProviderAffiliationStatusValueSchema = z.union([
  z.literal(0),
  z.literal(1),
])

export const ProviderAffiliationStatusSchema =
  ProviderAffiliationStatusValueSchema.transform((value) => {
    return value === 1 ? 'Active' : 'Inactive'
  })

export const ProviderAffiliationSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  logo: z.string().nullable(),
  status: ProviderAffiliationStatusSchema,
  connected_providers_count: z.number().optional(),
  created_datetime: z.string(),
  last_datetime: z.string(),
})

export type ProviderAffiliation = z.infer<typeof ProviderAffiliationSchema>
export type ProviderAffiliationStatusValue = z.infer<
  typeof ProviderAffiliationStatusValueSchema
>

export type ProviderAffiliationLogoInput = File | string | null

export type CreateProviderAffiliation = {
  name: string
  description?: string | null
  status?: ProviderAffiliationStatusValue
  logo_image?: ProviderAffiliationLogoInput
}

export type UpdateProviderAffiliation = {
  name?: string
  description?: string | null
  status?: ProviderAffiliationStatusValue
  logo_image?: File | null
}

export const DeleteProviderAffiliationResponseSchema = z.object({
  deleted: z.boolean(),
})

export type DeleteProviderAffiliationResponse = z.infer<
  typeof DeleteProviderAffiliationResponseSchema
>

export const RemoveProviderFromAffiliationResponseSchema = z.object({
  affiliation_id: z.number(),
  provider_id: z.number(),
  program_id: z.number(),
  removed: z.boolean(),
})

export type RemoveProviderFromAffiliationResponse = z.infer<
  typeof RemoveProviderFromAffiliationResponseSchema
>

export const AffiliationProviderSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  email: z.string().nullable(),
  status: z.number(),
})

export const PaginatedAffiliationProvidersSchema = z.object({
  current_page: z.number(),
  data: z.array(AffiliationProviderSchema),
  first_page_url: z.string(),
  from: z.number().nullable(),
  last_page: z.number(),
  last_page_url: z.string(),
  links: z.array(
    z.object({
      url: z.string().nullable(),
      label: z.string(),
      active: z.boolean(),
    })
  ),
  next_page_url: z.string().nullable(),
  path: z.string(),
  per_page: z.number(),
  prev_page_url: z.string().nullable(),
  to: z.number().nullable(),
  total: z.number(),
})

export type AffiliationProvider = z.infer<typeof AffiliationProviderSchema>

export type PaginatedAffiliationProviders = z.infer<
  typeof PaginatedAffiliationProvidersSchema
>

export const AddProvidersToAffiliationResponseSchema = z.object({
  affiliation_id: z.number(),
  requested_count: z.number(),
  inserted_count: z.number(),
  already_attached_count: z.number(),
})

export type AddProvidersToAffiliationResponse = z.infer<
  typeof AddProvidersToAffiliationResponseSchema
>
